import React from 'react';
import { Icon, InputAdornment, TableCell, TableRow, TextField } from '@material-ui/core';


const TableFilterRow = ({
  headTableCells,
  filters,
  setFilters
}) => {
  const handleChangeFilterValue = ({target: {value, name}}) => {
    if (value?.trim()) {
      setFilters(() => ({...filters, [name]: value}));
    } else {
      resetFilter(name);
    }
  };

  const resetFilter = (filterName: string) => {
    const {[filterName as keyof typeof filters]: _, ...restFilters} = filters;
    setFilters(restFilters);
  };

  return (
    <TableRow>
      {headTableCells.map((cell) => {
        if (!cell.filter) {
          return <TableCell  key={`filter-${cell.fieldName}`} />;
        }

        return (
          <TableCell key={`filter-${cell.fieldName}`}>
            <div className="flex items-center">
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                name={cell.fieldName}
                value={filters?.[cell.fieldName] || ''}
                onChange={handleChangeFilterValue}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {!filters?.[cell.fieldName]?.length ?
                        <Icon color="primary">filter_list</Icon>
                        :
                        <Icon
                          color="primary"
                          className="cursor-pointer"
                          onClick={() => resetFilter(cell.fieldName)}
                        >
                          close
                        </Icon>
                      }
                    </InputAdornment>
                  )
                }}
              />

            </div>
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default TableFilterRow;
